import { ExternalLink } from "lucide-react";

// Renders **bold** as plain text and bare URLs as links.
export const formatContent = (text) => {
  if (!text) return text;
  const parts = [];
  const combinedRegex = /(\*\*[^*]+\*\*)|(https?:\/\/[^\s]+)/g;
  let lastIndex = 0;
  let match;
  while ((match = combinedRegex.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.substring(lastIndex, match.index));
    if (match[1]) {
      parts.push(<span key={`b-${match.index}`} className="text-gray-200">{match[1].replace(/\*\*/g, "")}</span>);
    } else if (match[2]) {
      const url = match[2];
      parts.push(
        <a key={`l-${match.index}`} href={url} target="_blank" rel="noopener noreferrer"
          className="text-ism-teal hover:text-ism-teal/80 underline transition-colors inline-flex items-center gap-1"
          onClick={(e) => e.stopPropagation()}>
          {url.length > 60 ? url.substring(0, 60) + "..." : url}
          <ExternalLink className="h-3 w-3 inline" />
        </a>
      );
    }
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.substring(lastIndex));
  return parts.length > 0 ? parts : text;
};

// Splits text into paragraphs and "•" bullet items.
export const renderBulletContent = (content) => {
  const items = [];
  let currentParagraph = [];
  const flush = (key) => {
    if (!currentParagraph.length) return;
    items.push(<p key={key} className="text-gray-300 leading-relaxed mb-2">{formatContent(currentParagraph.join(" "))}</p>);
    currentParagraph = [];
  };
  (content || "").split("\n").forEach((line, idx) => {
    const trimmed = line.trim();
    if (trimmed.startsWith("•")) {
      flush(`p-${idx}`);
      items.push(<li key={`li-${idx}`} className="text-gray-300 leading-relaxed">{formatContent(trimmed.substring(1).trim())}</li>);
    } else if (trimmed) {
      currentParagraph.push(trimmed);
    } else {
      flush(`p-${idx}`);
    }
  });
  flush("final");
  return items;
};
